import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useConnectivityStore } from '@shared/hooks/useConnectivityStore';

/**
 * Persistent banner showing connectivity status.
 * - Online: no banner
 * - Offline: yellow — "Offline (read-only)"
 * - Disconnected: red — "Disconnected — only Support available"
 */
export default function ConnectivityBanner() {
  const state = useConnectivityStore((s) => s.state);

  if (state === 'online') return null;

  const isDisconnected = state === 'disconnected';

  return (
    <Box
      data-testid="connectivity-banner"
      sx={{
        px: 2,
        py: 0.5,
        bgcolor: isDisconnected ? 'error.main' : 'warning.main',
        color: isDisconnected ? 'error.contrastText' : 'warning.contrastText',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        {isDisconnected ? 'Disconnected — only Support available' : 'Offline (read-only)'}
      </Typography>
    </Box>
  );
}
